// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SharedEmailAddressPatientDataModel {
    static getAttributeTypeMap() {
        return SharedEmailAddressPatientDataModel.attributeTypeMap;
    }
}
SharedEmailAddressPatientDataModel.discriminator = undefined;
SharedEmailAddressPatientDataModel.additionalProperties = false;
SharedEmailAddressPatientDataModel.attributeTypeMap = [
    {
        "name": "emailAddressType",
        "baseName": "emailAddressType",
        "type": "ContactInfoPurposeType"
    },
    {
        "name": "address",
        "baseName": "address",
        "type": "string"
    },
    {
        "name": "language",
        "baseName": "language",
        "type": "string"
    },
];
//# sourceMappingURL=sharedEmailAddressPatientDataModel.js.map